import qbci2 from '../../../media/experience/qbci/7D53A3C4-948F-4494-AF3F-FD8B0D161109_1_105_c.jpeg';
import allostericPDF from '../../../media/papers/allosteric/Verk.pdf';
import allosteric2PDF from '../../../media/papers/allosteric2/ssrn-6314747.pdf';
import allosteric3PDF from '../../../media/papers/allosteric3/allosteric3.pdf';
import spikeBnAbPDF from '../../../media/papers/spike_bnab/ijms-27-04025-v2.pdf';

import qbci3 from '../../../media/experience/qbci/Gbci_Homepage.png';
import qbci4 from '../../../media/experience/qbci/TeamPage.png';
import qbci5 from '../../../media/experience/qbci/Picture2.png';
import qbci6 from '../../../media/experience/qbci/Picture3.png';
import qbci7 from '../../../media/experience/qbci/Picture4.jpg';
import qbci8 from '../../../media/experience/qbci/Picture5.jpg';
import qbci9 from '../../../media/experience/qbci/Picture6.jpg';
import qbci10 from '../../../media/experience/qbci/Picture7.jpg';
import qbciPoster from '../../../media/experience/qbci/analysis_student.png';

const qbciData = {
  company: "QBCI Lab",
  slug: "qbci lab",
  poster: qbciPoster,
  location: "Orange, CA",
  heroImage: qbci5,

  roles: [
    {
      title: "Machine Learning Engineer",
      start: "November 2024",
      end: "Present",
      summary: "At the Quantitative Biology and Computational Intelligence Lab at Chapman University, I work under Dr. Gennady Verkhivker on machine learning for protein structure prediction and drug discovery. I led a team developing an AI agent for allosteric ligand design, built as an MCP-based wrapper around Stanford's BIOMNI. We maintained a consistent architectural foundation while customizing tools to focus on allosteric mechanisms and integrating specialized databases such as the Allosteric Database (ASD). On Chapman's NVIDIA DGX A100 cluster, I run AlphaFold, DynamicBind, Chai, Boltz, Proteinix, and related models for structure prediction and ligand binding analysis. I developed scripts for RMSD calculations using PyMol's Python SDK and other computational tools. Based on my work with the HPC infrastructure, I advised the Chapman HPC board on hardware and software upgrades. I maintain 24/7 remote cluster access, implement multi-GPU CUDA pipelines, and have co-authored [[four peer-reviewed and preprint publications::MDPI · Immune escape::https://www.mdpi.com/1422-0067/27/9/4025::bioRxiv · Allosteric grammar::https://www.biorxiv.org/content/10.64898/2026.03.21.713412v1::SSRN · Co-folding::https://ssrn.com/abstract=6314747::JCTC · Allosteric binding::https://pubs.acs.org/doi/10.1021/acs.jctc.6c00427]] at the intersection of AI and drug discovery.",
    },
  ],

  techStack: [
    "Python",
    "TensorFlow",
    "PyTorch",
    "CUDA",
    "AlphaFold",
    "DynamicBind",
    "Chai",
    "Boltz",
    "Proteinix",
    "MCP Architecture",
    "Stanford BIOMNI",
    "PyMol Python SDK",
    "ASD Database",
    "HPC",
    "NVIDIA DGX A100",
    "Deep Learning",
    "Computational Biology",
    "Linux",
    "Bash",
    "GPU Computing",
    "AI Agents"
  ],

  gallery: [
    { type: 'image', src: qbci3, alt: 'QBCI Lab homepage' },
    { type: 'image', src: qbci4, alt: 'Research team page' },
    { type: 'image', src: qbci2, alt: 'HPC cluster interface' },
    { type: 'image', src: qbci5, alt: 'Computational biology research visualization' },
    { type: 'image', src: qbci6, alt: 'Protein structure analysis' },
    { type: 'image', src: qbci7, alt: 'ML model results' },
    { type: 'image', src: qbci8, alt: 'Research data visualization' },
    { type: 'image', src: qbci9, alt: 'Allosteric visualization' },
    { type: 'image', src: qbci10, alt: 'Deep learning model architecture' }
  ],

  links: {
    company: "https://verkhivkerlab.chapman.edu/",
  },
  documents: [
    {
      type: 'pdf',
      src: spikeBnAbPDF,
      externalLink: 'https://www.mdpi.com/1422-0067/27/9/4025',
      externalLabel: 'MDPI',
      title: 'SARS-CoV-2 Antibody Immune Escape',
      alt: 'Mechanisms of binding and immune escape resistance for broadly neutralizing antibodies targeting distinct conserved SARS-CoV-2 spike epitopes (Int. J. Mol. Sci.).'
    },
    {
      type: 'pdf',
      src: allosteric3PDF,
      externalLink: 'https://www.biorxiv.org/content/10.64898/2026.03.21.713412v1',
      externalLabel: 'bioRxiv',
      title: 'Decoding Allosteric Grammar with Explainable AI',
      alt: 'PLMs as diagnostic probes of kinase energetic organization: 453 human kinases, frustration analysis, and ABL kinase validation of orthosteric vs allosteric embedding.'
    },
    {
      type: 'pdf',
      src: allosteric2PDF,
      externalLink: 'https://ssrn.com/abstract=6314747',
      externalLabel: 'SSRN',
      title: 'AI Co-Folding Models for Allosteric Binding',
      alt: 'Systematic comparison of AlphaFold3, Protenix, Boltz-2, Chai-1, and DynamicBind on orthosteric vs allosteric complexes, with energy landscape and local frustration analysis.'
    },
    {
      type: 'pdf',
      src: allostericPDF,
      externalLink: 'https://pubs.acs.org/doi/10.1021/acs.jctc.6c00427',
      externalLabel: 'JCTC',
      title: 'Predicting and Decoding Allosteric Binding',
      alt: 'Integrates protein language models (ESM2) with local frustration analysis to interpret allosteric vs orthosteric binding site prediction.'
    }
  ],
  documentTitle: "Research & Publications"
};



export default qbciData;
